export const amplifyconfig = {
  region: "eu-west-1",
  userPoolId: "eu-west-1_0p2g8hTdH",
  userPoolWebClientId: "6g97t0e0g3t0skvkfnen0jvukd",
  authenticationFlowType: "CUSTOM_AUTH"
};
